
import { useState, useEffect } from 'react';
import { getBusinessSettings, type BusinessSettings } from '@/utils/businessService';

export const useBusinessSettings = () => {
  const [settings, setSettings] = useState<BusinessSettings | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const businessSettings = await getBusinessSettings();
        setSettings(businessSettings);
      } catch (error) {
        console.error('Error loading business settings:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadSettings();
  }, []);

  return {
    settings,
    isLoading,
  };
};
